import React from 'react';

import { YOUTUBE, FACEBOOK, INSTAGRAM, TWITTER, SNAPCHAT } from '../../utils/static-configuration';
import { scientificFormat, formatNumberWithPercentage } from '../../utils/helpers/formatting';

const AnalyticsAssetListFooter = ({ listName, totals, openEngagementScoreModal }) => {
  if (!listName) return null;

  const likes = scientificFormat(totals.get('likes'));
  const dislikes = scientificFormat(totals.get('dislikes'));
  const comments = scientificFormat(totals.get('comments'));
  const views = scientificFormat(totals.get('views'));
  const engagement = scientificFormat(totals.get('engagement'));
  const shares = scientificFormat(totals.get('shares'));
  const reach = scientificFormat(totals.get('reach'));
  const retweets = scientificFormat(totals.get('retweets'));
  const reactions = scientificFormat(totals.get('reactions'));
  const followers = scientificFormat(totals.get('followers'));

  const youtubeTotals = {
    first: likes,
    second: dislikes,
    third: comments,
    fourth: views,
    fifth: engagement,
  };

  const facebookTotals = {
    first: shares, // shares
    second: likes,
    third: reactions,
    fourth: comments,
    fifth: views, //engage
  };

  const twitterTotals = {
    first: retweets,
    second: likes,
    third: comments,
    fourth: reach,
    fifth: '',
  };

  const instagramTotals = {
    first: likes,
    second: comments,
    third: followers,
    fourth: views,
    fifth: engagement,
  };

  const footerOptions = {
    YOUTUBE: youtubeTotals,
    FACEBOOK: facebookTotals,
    INSTAGRAM: instagramTotals,
    TWITTER: twitterTotals,
  };

  const footerTotals = footerOptions[listName];

  return (
    <div className="asset-list-totals">
      <div className="flex-spacer">
        <h4>&nbsp;&nbsp;&nbsp;TOTALS</h4>
      </div>
      <div className="flex-item stat">
        <p className="large">{ footerTotals.first }</p>
      </div>
      <div className="flex-item stat">
        <p className="large">{ footerTotals.second }</p>
      </div>
      <div className="flex-item stat">
        <p className="large">{ footerTotals.third }</p>
      </div>
      <div className="flex-item stat">
        <p className="large">{ footerTotals.fourth }</p>
      </div>
      <div className="flex-item stat">
        <p className="large">{ footerTotals.fifth }</p>
      </div>
      <div className="flex-item-small" />
    </div>
  );
};

export default AnalyticsAssetListFooter;



/** WEBPACK FOOTER **
 ** ./src/components/analytics-asset-list-totals/index.js
 **/